<template>
  <div class="form-module">
    <div class="container">
      <div class="title">坐标编辑</div>
      <button class="close-btn" @click="sendDataToParent('close')">×</button>
    </div>
    <div class="form-container">
      <div class="form">
        <a-form-model :label-col="{ span: 7 }" :wrapper-col="{ span: 17 }">
          <a-form-model-item label="物探点号" class="coordinateEditor">
            {{ coordinateForm.intuitionPoint }}
          </a-form-model-item>
          <a-form-model-item label="坐标 X" class="coordinateEditor">
            <a-input placeholder="请填写X坐标" v-model="coordinateForm.measurementLongitude" />
          </a-form-model-item>
          <a-form-model-item label="坐标 Y" class="coordinateEditor">
            <a-input placeholder="请填写Y坐标" v-model="coordinateForm.measurementLatitude" />
          </a-form-model-item>
          <a-form-model-item label="高程 Z" class="coordinateEditor">
            <a-input placeholder="请填写高程" v-model="coordinateForm.groundElevation" />
          </a-form-model-item>
          <!-- <a-form-model-item label="" class="coordinateEditor">
            <div style="display: flex; height: 34px; width: 237px;"> -->
          <!-- 按钮在左侧 -->
          <!-- <a-button :type="getShow ? 'danger' : 'primary'" @click="getMapLatLng()">
                {{ getShow ? '取消获取' : '获取地图坐标' }}
              </a-button> -->

          <!-- 内部的 div 在右侧并排 -->
          <!-- <div v-if="coordinateDatas != undefined"
                style="display: flex; flex-direction: column; height: 100%; flex: 1; margin-left: 8px;">
                <div style="flex: 1;  font-size: 12px; line-height: 16px; padding: 2px; box-sizing: border-box;">
                  X: <span style="color: #fe8d8f;">{{ coordinateData.lng.toFixed(7) }}</span></div>
                <div style="flex: 1; font-size: 12px; line-height: 16px; padding: 2px; box-sizing: border-box;">
                  Y:<span style="color: #fe8d8f;"> {{ coordinateData.lat.toFixed(7) }}</span></div>
              </div> -->
          <!-- </div>
          </a-form-model-item> -->
        </a-form-model>
      </div>
      <div class="form-buttons">
        <a-button style="margin-right: 10px;" @click="resetForm">重置</a-button>
        <a-button type="primary" @click="onSubmit">确定</a-button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CoordinateModule',
  props: {
    coordinateEditorData: Object, //当前对象
    coordinateData: Object, //点击地图坐标
  },
  watch: {
    coordinateData (newVal, oldVal) {
      console.log('coordinateData 发生了变化:', '旧值：', oldVal, '新值：', newVal);
      this.coordinateDatas = newVal
    }
  },
  created () {
    this.coordinateForm = JSON.parse(JSON.stringify(this.coordinateEditorData));
  },
  data () {
    return {
      form: {},
      labelCol: { span: 7 },
      wrapperCol: { span: 17 },
      getShow: false,
      coordinateForm: {},
      coordinateDatas: undefined
    };
  },
  methods: {
    // 发送给父组件信息
    sendDataToParent (item) {
      this.$emit('coordinate-to-parent', item);
    },
    //获取地图坐标
    getMapLatLng () {
      this.getShow = !this.getShow
      this.sendDataToParent({
        type: 'get',
        flag: this.getShow
      })
    },
    // 重置表单
    resetForm () {
      this.coordinateDatas = undefined
      this.coordinateForm = JSON.parse(JSON.stringify(this.coordinateEditorData));
    },
    // 提交表单
    onSubmit () {
      console.log(this.form);
      this.sendDataToParent({ //区分是地图移动管点还是输入坐标编辑
        type: this.coordinateDatas != undefined ? 'move' : 'fill',
        data: this.coordinateDatas != undefined ? {
          id: this.coordinateEditorData.id,
          obscureLongitude: this.coordinateDatas.lng,
          obscureLatitude: this.coordinateDatas.lat
        } : {
          id: this.coordinateForm.id,
          measurementLongitude: this.coordinateForm.measurementLongitude,
          measurementLatitude: this.coordinateForm.measurementLatitude,
          groundElevation: this.coordinateForm.groundElevation,
        }
      });
    },

  },
};
</script>

<style lang="less" scoped>
.form-module {
  padding: 2px 9px;
  // caret-color: transparent;
}

/* 容器样式 */
.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
}

.title {
  flex: 1;
  font-size: 15px;
  padding-left: 10px;
}

.close-btn {
  cursor: pointer;
  font-size: 25px;
  color: #5e5c5c;
  background: none;
  border: none;
  padding: 0 7px;
}

.close-btn:hover {
  color: #c00;
}

/* 表单容器 */
.form-container {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  height: 265px;
  /* 固定高度 */
  overflow: hidden;
  /* 隐藏外部盒子的滚动条 */
}

/* 表单内容 */
.form {
  flex: 1;
  overflow-y: hidden;
  /* 隐藏表单内容的滚动条 */
  overflow-x: hidden;
  padding-left: 10px;
}

/* 底部按钮 */
.form-buttons {
  padding: 10px;
  border-top: 1px solid #ccc;
  text-align: right;
}

/deep/ .ant-form-item-label>label {
  font-size: 12px;
}

.picker {
  min-width: 162px !important;
  width: 150px;
}

.dropdown {
  position: absolute;
  z-index: 1000;
  width: 150px;
  background-color: white;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  max-height: 200px;
  overflow-y: auto;

  .dropdown-radio {
    position: sticky;
    top: 0;
    width: 100%;
    overflow-x: auto;
  }

  .radio-group {
    display: flex;
    flex-wrap: wrap;
  }

  .radio-button {
    flex: 1 1 50%;
    box-sizing: border-box;
    text-align: center;
    line-height: 30px;
  }
}

.coordinateEditor {
  margin: 0;
}

/* 搜索容器 */
.search-container {
  position: relative;
}

/* 悬浮的搜索结果列表 */
.floating-results {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  z-index: 1000;
  margin-top: 5px;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* 列表样式 */
.results-list {
  max-height: 90px;
  /* 限制列表的最大高度 */
  overflow-y: auto;
  /* 列表超出时显示滚动条 */
}

/* 列表项样式 */
.result-item {
  padding: 5px 12px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.result-item:hover {
  background-color: #f5f5f5;
}
</style>